import { render, staticRenderFns } from "./Bhe.vue?vue&type=template&id=030b4188&scoped=true"
import script from "./Bhe.vue?vue&type=script&lang=js"
export * from "./Bhe.vue?vue&type=script&lang=js"
import style0 from "./Bhe.vue?vue&type=style&index=0&id=030b4188&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030b4188",
  null
  
)

export default component.exports